import type { ModuleDefinition } from '../../../app/moduleRegistry';
import BankListPage from './pages/BankListPage';

/** Banka Ayarları yönetimi — Master GSA only. Controller re-verified 2026-08-10 against
 *  localhost:1538 (GetBanks returned real rows); Edit-only. Confirm on the production host
 *  — see api/types/system.ts + docs/backend-requirements.md V-2. */
export const bankModule: ModuleDefinition = {
  routes: [{ path: 'system/bank', element: <BankListPage /> }],
  menuItems: [
    {
      label: 'Sistem: Banka Ayarları',
      path: 'system/bank',
      isVisible: (user) => !!user?.isMasterGsa,
    },
  ],
};
